import React, { useState, useEffect, useContext } from "react";
import {
    Dialog, DialogTitle, DialogContent, Button, Typography,
    DialogActions, IconButton, Grid, Tooltip, TextField,
    MenuItem, Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { FindInPage } from '@mui/icons-material';
import { DataGrid, esES, GridActionsCellItem, GridToolbar } from '@mui/x-data-grid';
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../app/store/root";
import { EnumStatusShipmentString } from "../../shared/Enumerables";
import { ModalComponent } from "../../app/common/ModalComponent";
import ModalDetalles from "../../shared/modals/ModalDetalles";
import DialogComponent from "../../app/common/DialogComponent";

const ModalGuiasEntregar = ({ onClose, onFinish, guiasEmbarque }) => {

    const rootStore = useContext(RootStoreContext);
    const {
        getById
    } = rootStore.shipmentStore;

    const [pageSize, setPageSize] = React.useState(5);

    //variable que almacena los envios seleccionados para cambio de estatus en el embarque.
    const [enviosSeleccionados, setEnviosSeleccionados] = React.useState([])
    const [showModalDetail, setShowModalDetail] = useState(false);

    const detalleEnvioEmbarque = async (detalle) => {
        let resp = await getById(detalle.idGuia)
        if (resp) {
            setShowModalDetail(true)
        }
    }

    //Modal Confirmar Cancelar
    const [showConfirmAceptar, setShowConfirmAceptar] = React.useState(false)
    const onAcceptCancelar = () => {
        onClose()
    }

    //Modal Confirmar Cancelar
    const [showConfirmCancel, setShowConfirmCancel] = React.useState(false)    

    useEffect(() => {
        setEnviosSeleccionados(guiasEmbarque.map(a => a.idGuia))
    }, [guiasEmbarque])

    // TABLE
    const columns = [
        {
            field: 'numeroGuia',
            headerName: 'No. guía',
            flex: 1,
            minWidth: 100,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">
                    No. guía
                </span>
            ),
        },
        {
            field: 'proveedor',
            headerName: 'Proveedor',
            flex: 1,
            minWidth: 100,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">
                    Proveedor
                </span>
            ),
        },
        {
            field: 'descripcionEnvio',
            headerName: 'Comentario adicional',
            minWidth: 150,
            flex: 1,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">
                    Comentario adicional
                </span>
            ),
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Acciones',
            headerClassName: 'tableHeaders',
            getActions: (params) => [
                <Tooltip title="Ver Detalle" placement="top">
                    <GridActionsCellItem
                        icon={<FindInPage />}
                        label="Detalle"
                        color='primary.main'
                        onClick={() => detalleEnvioEmbarque(params.row)}
                    />
                </Tooltip>
            ],
        },
    ];

    return (
        <div>
            <DialogTitle>
                Guías del embarque a entregar
                <IconButton aria-label="close"
                    onClick={(e) => setShowConfirmCancel(true)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <div className='mb-2 d-flex' >
                    <Typography variant='h5'>
                        Seleccione las guías a entregar del embarque
                    </Typography>
                </div>
                <Box sx={{
                    width: '100%',
                    '& .tableHeaders': {
                        color: 'primary.main',
                    },
                }}>
                    <DataGrid
                        getRowId={(row) => row.idGuia}
                        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                        autoHeight
                        isRowSelectable={(params) => params.row.estatus.toUpperCase() != EnumStatusShipmentString.Entregado}
                        checkboxSelection={true}
                        disableSelectionOnClick={true}
                        rows={guiasEmbarque}
                        columns={columns}
                        dataSource={guiasEmbarque}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        rowsPerPageOptions={[5, 10, 20]}
                        pagination
                        disableColumnFilter
                        disableColumnSelector
                        disableDensitySelector
                        components={{ Toolbar: GridToolbar }}
                        selectionModel={enviosSeleccionados}
                        componentsProps={{
                            toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: { debounceMs: 500 },
                                csvOptions: { disableToolbarButton: true },
                                printOptions: { disableToolbarButton: true },
                            },
                        }}
                        onSelectionModelChange={(ids) => {
                            setEnviosSeleccionados(ids)
                        }}
                    />
                </Box>
            </DialogContent>

            <DialogActions variant="paddi">
                <Button variant="contained" color="secondary" sx={{ color: '#fff' }}
                    onClick={(e) => {
                        e.preventDefault()
                        setShowConfirmCancel(true)
                    }}>
                    Cancelar
                </Button>
                <Button onClick={(e) => {
                    e.preventDefault()
                    setShowConfirmAceptar(true)
                }}
                    disabled={enviosSeleccionados.length == 0}
                    variant="contained">
                    Aceptar
                </Button>
            </DialogActions>
            <ModalComponent
                Open={showModalDetail}
                HandleClose={() => setShowModalDetail(false)}
                ClassName="modal-xl"
                Body={() => <ModalDetalles onClose={(e) => setShowModalDetail(false)} />}
            />
            <DialogComponent
                Open={showConfirmCancel}
                Message="¿Está seguro de que desea cerrar esta ventana?"
                OnClose={() => setShowConfirmCancel(false)}
                OnAccept={() => {
                    setShowConfirmCancel(false)
                    onAcceptCancelar()
                }}
            />
            <DialogComponent
                Open={showConfirmAceptar}
                Message="¿Está seguro que todos los datos son correctos?"
                OnClose={() => setShowConfirmAceptar(false)}
                OnAccept={() => {
                    setShowConfirmAceptar(false)
                    onFinish(enviosSeleccionados)
                }}
            />
        </div>
    );
}

export default observer(ModalGuiasEntregar);